// apps/spa/src/lib/queryClient.ts
// Single QueryClient instance for the SPA.
//
// Defaults per CONTEXT decisions:
//   - staleTime 30s — most lists tolerate small staleness; reduces refetch storms.
//   - refetchOnWindowFocus true — officers leaving the tab + coming back should see fresh data.
//   - retry 1 — transient KV/D1 jitter shouldn't surface as user-visible errors.

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});
